import { render } from "./CustomInputNumber.vue?vue&type=template&id=4b80fbba&scoped=true"
import script from "./CustomInputNumber.vue?vue&type=script&lang=js"
export * from "./CustomInputNumber.vue?vue&type=script&lang=js"

import "./CustomInputNumber.vue?vue&type=style&index=0&id=4b80fbba&scoped=true&lang=css"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b80fbba"]])

export default __exports__